<template>
  <div class="panel background-grey space-top-4em">
    <p class="font-alt large">
      <strong>Review this book</strong>
    </p>

    <p>
      Share your thoughts with other readers now.
    </p>

    <DBookWriteUserReviewButton
      :bookshelf="bookshelf"
      :book-slug="bookSlug"
      :book-url="bookUrl"
      class="button-full"
      :is-user-signed-in="isUserSignedIn"
    />
  </div>
</template>

<script>
import DBookWriteUserReviewButton from './d-book-write-user-review-button/d-book-write-user-review-button.vue';

export default {
  components: {
    DBookWriteUserReviewButton,
  },
  props: {
    bookshelf: {
      type: String,
      default: null,
    },
    bookSlug: {
      type: String,
      required: true,
    },
    bookUrl: {
      type: String,
      required: true,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
